
import React, { useState, useCallback, useEffect } from 'react'

import { Typography } from '@telavita-core/react-design-kit'

import { VerticalBar } from 'components/Charts/VerticalBar'

import { DaysViewData } from '../../types'

import {
  Container,
  Arrows,
  Graphic,
  GraphicWrapper,
  Legend,
  LegendItem,
  Circle,
} from './styles'

import ArrowLeftIcon from 'components/CoreIcons/Icons/ArrowLeft'
import ArrowRightIcon from 'components/CoreIcons/Icons/ArrowRight'

interface DayGraphicProps {
  data: DaysViewData[]
}

const DATA_LENGTH = 7

export function DayGraphic({
  data,
}: DayGraphicProps): JSX.Element {
  const [animateCarrossel, setAnimateCarrossel] = useState<'left' | 'right'>('left')
  const [leftArrowDisable, setLeftArrowDisable] = useState(false)
  const [rightArrowDisable, setRightArrowDisable] = useState(false)
  const [activeBarValues, setActiveBarValues] = useState<DaysViewData[]>([])

  const isLeftArrowDisable = useCallback(() => {
    if(activeBarValues.length < data.length) {
      const firstValueData = data[0]

      return activeBarValues.some(item => item.date === firstValueData.date)
    }

    return true
  }, [activeBarValues, data])

  const isRightArrowDisable = useCallback(() => {
    if(activeBarValues.length < data.length) {
      const lastValueData = data[data.length - 1]

      return activeBarValues.some(item => item.date === lastValueData.date)      
    }

    return true
  }, [activeBarValues, data])

  function navLeft() {
    const firstValueData = activeBarValues[0]

    const firstValueDataIndex = data.findIndex(item => item.date === firstValueData.date)
    const restData = data.slice(0, firstValueDataIndex)

    if (restData.length >= DATA_LENGTH) {
      const newBarValues = data.slice((firstValueDataIndex - DATA_LENGTH), firstValueDataIndex)
      setActiveBarValues(newBarValues)
    } else {
      const newBarValues = data.slice(0, DATA_LENGTH)
      setActiveBarValues(newBarValues)
    }

    setAnimateCarrossel('left')
  }

  function navRight() {
    const lastValueData = activeBarValues[activeBarValues.length - 1]

    const lastValueDataIndex = data.findIndex(item => item.date === lastValueData.date)
    const restData = data.slice((lastValueDataIndex + 1))
    
    if (restData.length >= DATA_LENGTH) {
      const newBarValues = data.slice((lastValueDataIndex + 1), (lastValueDataIndex + DATA_LENGTH + 1))
      setActiveBarValues(newBarValues)
    } else {
      const newBarValues = data.slice(-DATA_LENGTH)
      setActiveBarValues(newBarValues)
    }

    setAnimateCarrossel('right')
  }

  useEffect(() => {
    if (data.length) {
      const barValues = data.slice(-DATA_LENGTH)
      setActiveBarValues(barValues)
    }
  }, [data])

  useEffect(() => {
    if(!animateCarrossel) return
    setTimeout(() => {
      setAnimateCarrossel(null)
    }, 300)
  }, [animateCarrossel])

  useEffect(() => {
    setLeftArrowDisable(() => isLeftArrowDisable())
    setRightArrowDisable(() => isRightArrowDisable())
  }, [activeBarValues, isRightArrowDisable, isLeftArrowDisable])

  return (
    <Container>

      <Arrows>
        <button
          onClick={() => navLeft()}
          disabled={leftArrowDisable}
        >
          <ArrowLeftIcon 
            fill='#4b4b4b'
            height='24px'
            width='24px'
          />
        </button>
        <button
          onClick={() => navRight()}
          disabled={rightArrowDisable}
        >
          <ArrowRightIcon 
            fill='#4b4b4b'
            height='24px'
            width='24px'
          />
        </button>
      </Arrows>

      <GraphicWrapper>
        <Graphic
          animate={animateCarrossel}
        >
          {activeBarValues.map((item, index) => (
            <VerticalBar
              key={index}
              date={item.date}
              firstBarValue={item.slots}
              secondBarValue={item.schedules}
            />
          ))}
        </Graphic>
      </GraphicWrapper>


      <Legend>
        <LegendItem>
          <Circle 
            color='#d5d5d5'
          />
          <Typography
            variant='content3'
          >
            {<>Horários<br />disponibilizados</>}
          </Typography>
        </LegendItem>

        <LegendItem>
          <Circle 
            color='#1f35b5'
          />
          <Typography
            variant='content3'
          >
            {<>Agendamentos<br />recebidos</>}
          </Typography>
        </LegendItem>
      </Legend>

    </Container>
  )
}